export default __webpack_public_path__ + "static/media/liked-video.4df5a917.svg";